import { render, staticRenderFns } from "./columnSetting.vue?vue&type=template&id=1aa548db&scoped=true&"
import script from "./columnSetting.vue?vue&type=script&lang=ts&"
export * from "./columnSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa548db",
  null
  
)

export default component.exports